module.exports = "<section id=\"user-account-data\">\n    PS\n</section>";


//////////////////
// WEBPACK FOOTER
// ./src/app/sections/registration/paypal-success/paypal-success.html
// module id = 529
// module chunks = 0